var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50391 8C6.71305 8 8.50391 6.20914 8.50391 4C8.50391 1.79086 6.71305 -9.23012e-08 4.50391 0C2.29477 9.23012e-08 0.503906 1.79086 0.503906 4C0.503906 6.20914 2.29477 8 4.50391 8ZM22.5039 4.75C22.9181 4.75 23.2539 4.41421 23.2539 4C23.2539 3.58579 22.9181 3.25 22.5039 3.25L22.5039 4L22.5039 4.75ZM4.50391 4L4.50391 4.75L22.5039 4.75L22.5039 4L22.5039 3.25L4.50391 3.25L4.50391 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 12.25C0.335786 12.25 -1.73065e-08 12.5858 0 13C1.73065e-08 13.4142 0.335786 13.75 0.75 13.75L0.75 13L0.75 12.25ZM18.75 17C20.9591 17 22.75 15.2091 22.75 13C22.75 10.7909 20.9591 9 18.75 9C16.5409 9 14.75 10.7909 14.75 13C14.75 15.2091 16.5409 17 18.75 17ZM0.75 13L0.75 13.75L18.75 13.75L18.75 13L18.75 12.25L0.75 12.25L0.75 13Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-icon.af739685f3b59cb24a2a2427605d8713.svg";